import { useQuery } from "@apollo/client";
import { WANTED_ITEMS } from "../wantedItemTypeDefs";

export const useQueryWantedItems = (options?: any): any => (
  useQuery(WANTED_ITEMS, options)
);
